var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReapLogoNotext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1333.3333 772.70667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g33",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,772.70667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g35",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 213.602,2096.33 7915.118,14.52 62.94,43.57 33.89,-29.05 87.14,87.15 67.78,-58.1 72.62,125.88 87.15,-91.99 121.03,164.61 121.04,-128.3 183.97,244.49 135.56,-186.39 227.55,254.17 140.4,-220.28 256.59,321.95 174.29,-271.12 V 2033.39 H 8041.57 C 6942.96,2038.32 5475.64,1936.14 3806.82,1504.77 2217.11,1093.85 936.379,511.352 0,0 c 18.6445,144.391 45.5977,315.988 134.348,482.93 152.504,286.851 475.668,664.48 1158.312,1027.59 0,0 -937.918,357.76 -1079.34,585.33 -0.132,0.21 0.032,0.48 0.282,0.48",
    style: {
      fill: "#c1b5b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 82.3047,1384.64 c 0,0 -38.7305,151.7 493.8243,187.2 0,0 216.25,9.68 219.476,-93.6 3.227,-103.28 -268.515,-158.15 -356.964,-180.75 -88.446,-22.59 -340.1996,-9.68 -356.3363,87.15",
    style: {
      fill: "#c1b5b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9683.63,4228.16 c -26.66,-447.81 -453.96,-618.25 -601.98,-664.03 -29.34,-9.08 -59.7,-14.16 -90.4,-15.39 l -766.5,-30.66 v 1420.15 h 634.36 c 179.08,0 355.58,-50.46 503.82,-150.93 341.19,-231.21 320.7,-559.14 320.7,-559.14 z m -419.43,894.4 c -100.12,32.24 -204.89,48.06 -310.07,48.06 H 7921.35 V 2298.05 h 309.85 v 994.1 l 737.69,9.58 c 241.15,3.13 476.39,82.61 665.29,232.53 184.6,146.5 362.66,368.52 365.75,680.99 0,0 22.27,663.18 -735.73,907.31",
    style: {
      fill: "#2d2727",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1326.52,3564.13 c -29.35,-9.08 -59.7,-14.16 -90.4,-15.39 l -766.503,-30.66 v 1420.15 h 634.353 c 179.09,0 355.58,-50.46 503.83,-150.93 341.19,-231.21 320.69,-559.14 320.69,-559.14 -26.65,-447.81 -453.95,-618.25 -601.97,-664.03 z m 918.28,651.12 c 0,0 22.29,663.18 -735.73,907.31 -100.12,32.24 -204.89,48.06 -310.07,48.06 H 166.223 V 2298.05 H 476.07 v 994.1 l 541.26,7.03 817.56,-980.15 h 387.32 l -827.04,999.72 c 175.9,30.93 342.81,103.56 483.88,215.51 184.6,146.5 362.65,368.52 365.75,680.99",
    style: {
      fill: "#2d2727",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2690.21,3752.09 c 0,655.09 495.29,1186.14 1106.26,1186.14 248.48,0 477.82,-87.85 662.5,-236.15 L 2914.38,3036.25 c -140.66,198.96 -224.17,446.93 -224.17,715.84 z m 1953.31,-762.86 c -202.93,-258.77 -507.05,-423.29 -847.05,-423.29 -285.37,0 -545.49,115.88 -741.7,306.12 l 1566.72,1670.13 173.7,182.06 c -0.45,0.55 -0.89,1.11 -1.35,1.66 v 0 h -0.01 c -247.21,294.86 -604.99,480.21 -1003.01,480.21 -746,0 -1350.75,-650.99 -1350.75,-1454.03 0,-803.05 604.75,-1454.04 1350.75,-1454.04 454.13,0 855.91,241.26 1100.79,611.2 l -248.09,79.98",
    style: {
      fill: "#83c13a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5895.61,3626.21 456.31,987.65 462.51,-987.65 z M 7436.4,2298.05 h 334.06 L 6424.54,5170.62 H 6279.3 c 0,0 -1331.38,-2861.27 -1345.91,-2872.57 h 348.58 l 501.8,1086.09 H 6927.79 L 7436.4,2298.05",
    style: {
      fill: "#2d2727",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path47"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReapLogoNotext);
export default __webpack_public_path__ + "static/media/reap-logo-notext.9ada266b0da4abbebce0b6939c70ef35.svg";
export { ForwardRef as ReactComponent };